// Funções utilitárias para encriptação simples do email
export const encryptEmail = (email: string): string => {
  return btoa(email); // Base64 encode
};

export const decryptEmail = (encryptedEmail: string): string => {
  try {
    return atob(encryptedEmail); // Base64 decode
  } catch (error) {
    return "";
  }
};

// Gerar link de continuação do cadastro
export const generateContinueRegistrationLink = (
  email: string,
  isAdLink: boolean = false
): string => {
  const encryptedEmail = encryptEmail(email);
  const currentDomain = window.location.origin;
  const route = isAdLink ? "/continuar-cadastro-adlink" : "/continuar-cadastro";
  return `${currentDomain}${route}?token=${encryptedEmail}`;
};

// Copiar texto para clipboard
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    // Fallback para navegadores mais antigos
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      document.body.removeChild(textArea);
      return true;
    } catch (err) {
      document.body.removeChild(textArea);
      return false;
    }
  }
};
